var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',{attrs:{"chips":"","multiple":"","auto-select-first":"","label":_vm.label,"items":_vm.items,"outlined":"","dense":""},on:{"change":function($event){return _vm.$emit('input', _vm.valueString)}},model:{value:(_vm.localValues),callback:function ($$v) {_vm.localValues=$$v},expression:"localValues"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }